import type { QuizGradeOutcome } from "./quiz-grade-result";

export type PrismaQuizGradeOutcome = "CORRECT" | "PARTIAL" | "INCORRECT";

export function toPrismaQuizGradeOutcome(
	outcome: QuizGradeOutcome,
): PrismaQuizGradeOutcome {
	if (outcome === "correct") {
		return "CORRECT";
	}
	if (outcome === "partial") {
		return "PARTIAL";
	}
	return "INCORRECT";
}

export function fromPrismaQuizGradeOutcome(
	outcome: PrismaQuizGradeOutcome,
): QuizGradeOutcome {
	if (outcome === "CORRECT") {
		return "correct";
	}
	if (outcome === "PARTIAL") {
		return "partial";
	}
	return "incorrect";
}
